(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-catalog"]) return;
  try {
    
  function filterByCollection(collectionHandle) {
    const items = document.querySelectorAll('.catalog-item');
    
    items.forEach(item => {
      if (collectionHandle === 'all' || item.dataset.collection === collectionHandle) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });
  }

  function sortProducts(sortBy) {
    const grid = document.getElementById('catalog-grid');
    const items = Array.from(grid.querySelectorAll('.catalog-item'));
    
    items.sort((a, b) => {
      const titleA = a.querySelector('.catalog-title').textContent;
      const titleB = b.querySelector('.catalog-title').textContent;
      const priceA = parseFloat(a.querySelector('.catalog-price-current').textContent.replace(/[^0-9.]/g, ''));
      const priceB = parseFloat(b.querySelector('.catalog-price-current').textContent.replace(/[^0-9.]/g, ''));
      
      switch(sortBy) {
        case 'price-ascending':
          return priceA - priceB;
        case 'price-descending':
          return priceB - priceA;
        case 'title-ascending':
          return titleA.localeCompare(titleB);
        case 'title-descending':
          return titleB.localeCompare(titleA);
        default:
          return 0;
      }
    });
    
    items.forEach(item => grid.appendChild(item));
  }

  } catch(e) { console.error(e); }
})();
})();
